import { PhoneDevice } from '@/api' 

export default {
  namespaced: true,

  state: ({
    availableDevices: []
    // PhoneDevice difinition
    // id: self.id,
    // phone_device_id: self.phone_device_id,
    // phone_device_description: self.phone_device_description,
    // phone_device_token: self.phone_device_token,
    // push_target: self.push_target,
    // created_at: self.created_at,
    // call_state: self.call_state,
    // available: self.available
}),

  mutations: {
    setAvailableDevices (state, payload) {
      state.availableDevices = payload
    },
  },

  getters: {},

  actions: {
    fetchAvailableDevices ({commit}) {
      return PhoneDevice.fetch().then(res => {
        console.log('on store/modules/PhoneDevice')
        console.log(res)
        commit('setAvailableDevices', res.data.phone_devices)
      })
    },

    create (context, payload) {
      return PhoneDevice.create(payload).then(res => {
        console.log(res)
        return {
          user_id: res.data.user.id,
          user_name: res.data.user.name,
          user_account_name: res.data.user.account_name,
          user_email: res.data.user.email,
          narrative_phone_id: res.data.user.narrative_phone_id,
          ios_zoom_available: res.data.user.ios_zoom_available,
          android_zoom_available: res.data.user.android_zoom_available,
          phone_device_id: res.data.phone_device.phone_device_id,
          phone_device_target: res.data.phone_device.push_target,
          phone_device_authenticate_token: res.data.phone_device.device_authenticate_token
        }
      })
    }

  }
}